import { ModifiedDrawer as AntdModifiedDrawer } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const ModifiedDrawer = forwardRef((props, ref) => {
  return <AntdModifiedDrawer ref={ref} {...props} />
})

export default ModifiedDrawer
